import React from "react";
import { Box, Typography } from "@mui/joy";
import CircularProgress from "@mui/joy/CircularProgress";

const Loading: React.FC<{ message?: string }> = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <CircularProgress size="lg" color="primary" sx={{ marginBottom: "20px" }} />
      <Typography level="h3">{message}</Typography>
    </Box>
  );
};

export default Loading;
